// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__1Xgf7","alertIcon":"ConfirmModal_alertIcon__1FJLP"};